import React, { useState, useEffect } from "react";
import { useAuth } from "../context/AuthContext";
import { ChevronDown, ChevronRight } from "lucide-react";
/* --- Pages --- (kept same imports as your original file) */
import Dashboard from "../pages/dashboard/Dashboard";
import SalesOrderListPage from "../pages/SalesOrder/SalesOrderList";
import AddSalesOrderPage from "../pages/SalesOrder/AddSalesOrderPage";
import SalesOrderDetailsPage from "../pages/SalesOrder/SalesOrderDetailsPage";
import SalesOrderNewItem from "../pages/SalesOrder/SalesOrderNewItem";
import AllotSalesOrderToPerson from "../pages/SalesOrder/AllotSalesOrderToPerson";
import PendingSalesView from "../pages/SalesOrder/PendingSalesView";

import PurchaseOrderListRev from "../pages/PurchaseOrder/PurchaseOrderListRev";
import AddPurchaseOrderPage from "../pages/PurchaseOrder/AddPurchaseOrderPage";
import PurchaseOrderNewItem from "../pages/PurchaseOrder/PurchaseOrderNewItem";
import PurchaseOrderDetailsPage from "../pages/PurchaseOrder/PurchaseOrderDetailsPage";

import OrderListPage from "../pages/order/OrderListPage";
import AddOrderPage from "../pages/order/AddOrderPage";
import OrderDetailsPage from "../pages/order/OrderDetailsPage";
import OrderNewItem from "../pages/order/OrderNewItem";
import PaymentScreen from "../pages/order/PaymentScreen";
import OnlineOrderPage from "../pages/order/OnlineOrderPage";
import PendingView from "../pages/order/PendingView";
import AllotOrderToPerson from "../pages/order/AllotOrderToPerson";

import CustomerListPage from "../pages/customer/CustomerListPage";
import AddEditCustomerPage from "../pages/customer/AddEditCustomerPage";
import CustomerLedgerPage from "../pages/Customerledger/CustomerLedgerPage";
import PurchaseOrderListPage from "../pages/order/Purchaseorderlist";
import SupplierListPage from "../pages/suppiler/SupplierListPage";
import AddEditSupplierPage from "../pages/suppiler/AddEditSupplierPage";
import SupplierReceiptsPage from "../pages/ReceiptsPage/SupplierReceiptsPage";

import ReceiptsPage from "../pages/ReceiptsPage/ReceiptsPage";
import ExpensePage from "../pages/ReceiptsPage/ExpensePage";
import Cancelpage from "../pages/ReceiptsPage/Cancelpage";
import CancelListpage from "../pages/ReceiptsPage/CancelListpage";

import ItemMaster from "../pages/item/ItemMaster";
import ItemListPage from "../pages/item/ItemListPage";

import Bankaccount from "../pages/Bank/Bankaccount";



import OpeningBalanceList from "../pages/order/OpeningBalanceList";
import OpeningBalanceAdd from "../pages/order/OpeningBalanceAdd";
import OpeningBalanceEdit from "../pages/order/OpeningBalanceEdit";


import StockListPage from "../pages/order/StockListPage";
import AddStockPage from "../pages/order/AddStockPage";
import StockDetailsPage from "../pages/order/StockDetailsPage";
import StockNewItem from "../pages/order/StockNewItem";

import DeliveryList from "../pages/DeliveryList/Deliverylist";
import DeliveryPendingView from "../pages/DeliveryList/DeliveryPendingView";
import DeliveryAllotOrderToPerson from "../pages/DeliveryList/DeliveryAllotOrderToPerson";

import Report from "../pages/report/Report";
import DeliveryMIS from "../pages/report/DeliveryMIS";
import StockReport from "../pages/report/StockReport";
import OrdervsStock from "../pages/report/OrdervsStock";
import SalesPurchaseMis from "../pages/report/SalesPurchaseMis";
import SalesPurReport from "../pages/report/SalesPurReport";

import Employeemaster from "../pages/Master/Employeemaster";
import BillingModule from "../components/BillingModule/BillingModule";
import ChangePassword from "../pages/order/ChangePassword";
import Counter from "../pages/order/Counter";

/* --- API --- */
import api from "../api/api";

const AppShell = () => {
  const [view, setView] = useState("dashboard");
  const [editingContext, setEditingContext] = useState(null);
  const [open, setOpen] = useState(false); // mobile sidebar open
  const [menus, setMenus] = useState([]);
  const { user, logout } = useAuth();
  const [companyInfo, setCompanyInfo] = useState({ name: "", address: "" });
  const [gdName, setGdName] = useState(sessionStorage.getItem("gdname") || "");
  const [gdid, setGdid] = useState(sessionStorage.getItem("gdid") || "");
  const [cancelList, setCancelList] = useState([]);
  const [openMenus, setOpenMenus] = useState({}); // accordion open state
  const toggleMenu = (menu) => setOpenMenus((prev) => ({ ...prev, [menu]: !prev[menu] }));

  // -------------------------
  // Fetch menus (robust parsing)
  // -------------------------
  useEffect(() => {
    const fetchMenus = async () => {
      try {
        const response = await api.RmpMenuListAPI(user?.UsrName || user);
        console.log("🔍 Full API response:", response);

        // Try several likely shapes:
        const apiRoot =
          response?.data?.RmpMenuListAPIjs ??
          response?.RmpMenuListAPIjs ??
          response?.data ??
          response;

        const menusData = apiRoot?.Table ?? [];
        console.log(" Menus extracted:", menusData);
        setMenus(menusData);
      } catch (err) {
        console.error(" Error fetching menus:", err);
        setMenus([]);
      }
    };

    fetchMenus();
  }, [user]);

  // -------------------------
  // Fetch company details (unchanged logic)
  // -------------------------
  useEffect(() => {
    const fetchCompanyDetails = async () => {
      try {
        const usernameToSend = typeof user === "object" ? user.UsrName : user;
        const data = await api.CompanyDetails(usernameToSend);

        if (data?.Table?.length > 0) {
          const c = data.Table[0];
          setCompanyInfo({ name: c.Comname || "Company Name", address: c.Address || "" });
        }
        if (sessionStorage.getItem("gdid") && data?.Table1?.length > 0) {
          const savedGdId = sessionStorage.getItem("gdid");
          const gd = data.Table1.find((g) => g.GdId.toString() === savedGdId);
          if (gd) {
            setGdName(gd.GodownName);
            setGdid(savedGdId);
            sessionStorage.setItem("gdname", gd.GodownName);
          }
        }
      } catch (err) {
        console.error("Error loading company details", err);
        setCompanyInfo({ name: "Company Name", address: "" });
      }
    };
    fetchCompanyDetails();
  }, [user]);

  // Listen for godown changes

  useEffect(() => {
    const handleGodownChange = () => {
      setGdName(sessionStorage.getItem("gdname") || "");
      setGdid(sessionStorage.getItem("gdid") || "");
    };
    window.addEventListener("godownChanged", handleGodownChange);
    handleGodownChange();
    return () => window.removeEventListener("godownChanged", handleGodownChange);
  }, []);

  // -------------------------
  // Shortcut F2: add sales order (unchanged)
  // -------------------------
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === "F2") {
        e.preventDefault();
        setView("add-salesorder");
      }
    };
    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, []);

  // -------------------------
  // Group menus by MenuType for accordion
  // -------------------------
  // const groupedMenus = menus.reduce((acc, m) => {
  //   const type = m.MenuType || "Other";
  //   if (!acc[type]) acc[type] = [];
  //   acc[type].push(m);
  //   return acc;
  // }, {});

  const groupedMenus = menus.reduce((acc, m) => {
    const type = m.MenuType || "Other";
    if (!acc[type]) acc[type] = [];
    acc[type].push(m);
    return acc;
  }, {});

  // order groups (optional) - will display in this order if present
  // const groupOrder = ["Orders", "Purchase", "Accounts", "Stock", "Report", "Other"];
  const groupOrder = Array.from(
    new Set(menus.map((m) => m.MenuType || "Other"))
  );

  // -------------------------
  // Render view (case-insensitive)
  // -------------------------
  const renderView = () => {
    const key = String(view || "").toLowerCase();

    switch (key) {
      case "dashboard":
        return <Dashboard setView={setView} setEditingContext={setEditingContext} />;

      // Sales orders & sales pages
      case "salesorders":
        return <SalesOrderListPage setView={setView} setEditingContext={setEditingContext} />;
      case "add-salesorder":
        return <AddSalesOrderPage setView={setView} setEditingContext={setEditingContext} />;
      case "edit-salesorder":
        return <SalesOrderDetailsPage setView={setView} context={editingContext} />;
      case "new-salesorder":
        return <SalesOrderNewItem setView={setView} context={editingContext || {}} />;
      case "pending-salesview":
      case "pending-sales-view":
        return <PendingSalesView setView={setView} />;
      case "allotsalesordertoperson":
        return <AllotSalesOrderToPerson setView={setView} />;

      // Purchase orders
      case "purchaseorders":
        return <PurchaseOrderListRev setView={setView} setEditingContext={setEditingContext} />;
      case "add-purchaseorder":
        return <AddPurchaseOrderPage setView={setView} setEditingContext={setEditingContext} />;
      case "edit-purchaseorder":
      case "purchaseorderdetails":
        return <PurchaseOrderDetailsPage setView={setView} context={editingContext} />;
      case "new-purchaseorder":
        return <PurchaseOrderNewItem setView={setView} context={editingContext || {}} />;

      // Orders
      case "orders":
        return <OrderListPage setView={setView} setEditingContext={setEditingContext} />;
      case "add-order":
        return <AddOrderPage setView={setView} setEditingContext={setEditingContext} />;
      case "edit-order":
        return <OrderDetailsPage setView={setView} context={editingContext} />;
      case "new-order":
        return <OrderNewItem setView={setView} context={editingContext || {}} />;
      case "pending-view":
      case "pending":
        return <PendingView setView={setView} />;

      // Customers
      case "customers":
        return <CustomerListPage setView={setView} setEditingContext={setEditingContext} />;
      case "add-customer":
        return <AddEditCustomerPage setView={setView} setCustomerId={setEditingContext} />;
      case "edit-customer":
        return <AddEditCustomerPage setView={setView} customerId={editingContext} setCustomerId={setEditingContext} />;

      // Supplier
      case "supplier":
      case "suppliers":
        return <SupplierListPage setView={setView} setEditingContext={setEditingContext} />;
      case "purchase": return <PurchaseOrderListPage setView={setView} context={editingContext || {}} />;
      case "add-supplier":
      case "addsupplier":
        return <AddEditSupplierPage setView={setView} setSupplierId={setEditingContext} />;
      case "edit-supplier":
        return <AddEditSupplierPage setView={setView} supplierId={editingContext} setSupplierId={setEditingContext} />;

      // Payments / Receipts / Accounts
      case "receipt":
      case "receipts":
        return <ReceiptsPage setView={setView} />;
      case "supplierpayment":
      case "supplier-payment":
        return <SupplierReceiptsPage setView={setView} />;


      // Opening Balance Pages
      case "openingbalancelist":
      case "opening-balance":
        return <OpeningBalanceList setView={setView} setEditingContext={setEditingContext} />;

      case "openingbalanceform":
        return <OpeningBalanceAdd setView={setView} />;

      case "openingbalanceedit":
        return <OpeningBalanceEdit setView={setView} editingContext={editingContext} />;


      case "expense":
        return <ExpensePage setView={setView} />;

      case "bankaccount":
      case "bank":
        return <Bankaccount setView={setView} />;

      // Reports
      case "report":
      case "gnrl. report":
      case "gnrl. report".toLowerCase():
        return <Report />;
      case "deliverymis":
      case "delivery-mis":
        return <DeliveryMIS setView={setView} />;
      case "stockreport":
      case "stock-report":
        return <StockReport />;
      case "ordervsstock":
      case "order-vs-stock":
        return <OrdervsStock />;
      case "salespurchasemis":
        return <SalesPurchaseMis setView={setView} />;
      case "salespurreport":
      case "salespurreport":
        return <SalesPurReport setView={setView} context={editingContext} />;

      // Stock pages
      case "stock-adjustment":
      case "stockadjustment":
        return <StockListPage setView={setView} context={editingContext || {}} />;
      case "add-stock":
        return <AddStockPage setView={setView} setEditingContext={setEditingContext} />;
      case "edit-stock":
        return <StockDetailsPage setView={setView} context={editingContext} />;
      case "new-stock":
        return <StockNewItem setView={setView} context={editingContext || {}} />;
      case "customer-ledger":
        return <CustomerLedgerPage />;

      // Item master and item list
      case "itemmaster":
      case "items":
        return <ItemMaster setView={setView} />;
      case "pricelist":
      case "price list":
        return <ItemListPage setView={setView} />;

      // Misc
      case "online-order":
      case "onlineorder":
        return <OnlineOrderPage />;
      case "getpaymentval":
        return <PaymentScreen editingContext={editingContext} setView={setView} />;
      case "cancel":
      case "cancelled documents":
      case "cancelleddocuments":
        return <Cancelpage setView={setView} cancelList={cancelList} setCancelList={setCancelList} />;
      case "cancelnew":
        return <CancelListpage setView={setView} setCancelList={setCancelList} />;
      case "employeemaster":
      case "employeemaster":
        return <Employeemaster setView={setView} />;
      case "changepassword":
        return <ChangePassword setView={setView} />;
      case "counter":
      case "counter":
        return <Counter setView={setView} />;

      // Delivery
      case "deliverylist":
        return <DeliveryList setView={setView} />;
      case "delivery-pending-view":
      case "deliverypendingview":
        return <DeliveryPendingView setView={setView} />;
      case "deliveryallotordertoperson":
      case "delivery-allot":
        return <DeliveryAllotOrderToPerson setView={setView} />;

      // default fallback — still supports API-driven menu
      default:
        // if view corresponds to an API menu name (case-insensitive), allow it (we just render Dashboard as placeholder)
        // You can expand this default area to render specialized components if needed.
        if (menus.some((m) => String(m.MenuName || "").toLowerCase() === key)) {
          // If the view is an API menu but no explicit case above, show Dashboard as a placeholder
          return <Dashboard setView={setView} setEditingContext={setEditingContext} />;
        }
        return <Dashboard setView={setView} setEditingContext={setEditingContext} />;
    }
  };

  // -------------------------
  // Helper: render ordered accordion groups
  // -------------------------
  const renderAccordionGroups = () => {
    // get keys in requested order, then remaining
    const keys = [
      ...groupOrder.filter((k) => groupedMenus[k]),
      ...Object.keys(groupedMenus).filter((k) => !groupOrder.includes(k)),
    ];

    return keys.map((type) => {
      const items = groupedMenus[type] || [];
      return (
        <div key={type} className="mb-2">
          <button
            onClick={() => toggleMenu(type)}
            className="flex items-center justify-between w-full px-3 py-2 font-semibold bg-gray-100 hover:bg-gray-200"
          >
            <span>{type}</span>
            {openMenus[type] ? <ChevronDown size={16} /> : <ChevronRight size={16} />}
          </button>

          {openMenus[type] && (
            <div className="pl-4">
              {items.map((m) => {
                const label = m.MenuLabel || m.MenuName;
                // clicking sets view to exact MenuName (we lower-case inside renderer)
                return (
                  <button
                    key={m.Menuid ?? label}
                    onClick={() => {
                      setView(String(m.MenuName));
                      setOpen(false); // close mobile (if opened)
                    }}
                    className={`block w-full px-2 py-1 text-left rounded hover:bg-gray-100`}
                  >
                    {label}
                  </button>
                );
              })}
            </div>
          )}
        </div>
      );
    });
  };

  // -------------------------
  // Main JSX
  // -------------------------
  return (
    <div className="flex min-h-screen bg-gray-100">
      {/* Mobile hamburger */}
      <button
        className="fixed z-20 p-3 bg-white rounded shadow md:hidden top-3 left-3"
        onClick={() => setOpen(!open)}
      >
        ☰
      </button>

      {/* Sidebar Desktop */}
      <aside className="flex-shrink-0 hidden w-64 p-4 bg-white shadow-lg md:block">
        <div className="mt-4 mb-2 text-2xl font-bold text-center text-gray-800">{companyInfo.name || "Loading..."}</div>
        <div className="mb-6 text-xs leading-snug text-center text-gray-600">{companyInfo.address}</div>

        {gdid && (
          <div className="mb-4 text-sm text-center text-gray-700">
            Godown: <span className="font-semibold">{gdName}</span>
          </div>
        )}

        <nav className="space-y-2 text-sm">
          {/* Dashboard fixed */}
          <button
            onClick={() => setView("dashboard")}
            className="block w-full px-2 py-1 text-left rounded hover:bg-gray-100"
          >
            Dashboard
          </button>

          {/* Dynamic accordion groups from API */}
          {renderAccordionGroups()}

          {/* Keep your existing static accordion blocks as fallback if needed 
              (if you want to keep original blocks in addition to API menus, add them here) */}
        </nav>

        {/* Logout */}
        <div className="pt-2 mt-auto text-center border-t">
          <p className="text-sm font-semibold">{user?.UsrName}</p>
          <button
            onClick={logout}
            className="w-full px-2 py-1 mt-2 text-white bg-red-500 rounded hover:bg-red-600"
          >
            Logout
          </button>
        </div>
      </aside>

      {/* Sidebar Mobile Popup */}
      {open && (
        <div className="absolute z-30 w-64 p-4 bg-white rounded shadow-lg md:hidden top-14 left-3">
          {gdid && (
            <div className="mb-3 text-sm text-center text-gray-700">
              Godown: <span className="font-semibold">{gdName}</span>
            </div>
          )}

          <nav className="space-y-2 text-sm">
            <button
              onClick={() => { setView("dashboard"); setOpen(false); }}
              className="block w-full px-2 py-1 text-left rounded hover:bg-gray-100"
            >
              Dashboard
            </button>

            {/* Mobile: same dynamic groups */}
            {Object.keys(groupedMenus).length === 0 ? (
              <div className="px-2 py-1 text-sm text-gray-500">No menus available</div>
            ) : (
              Object.keys(groupedMenus).map((type) => (
                <div key={`mob-${type}`}>
                  <button
                    onClick={() => toggleMenu(`mob-${type}`)}
                    className="flex items-center justify-between w-full px-2 py-1 font-semibold text-left rounded hover:bg-gray-100"
                  >
                    <span>{type}</span>
                    {openMenus[`mob-${type}`] ? <ChevronDown size={16} /> : <ChevronRight size={16} />}
                  </button>

                  {openMenus[`mob-${type}`] && (
                    <div className="mt-1 ml-4 space-y-1">
                      {groupedMenus[type].map((m) => (
                        <button
                          key={`mob-${m.Menuid}`}
                          onClick={() => { setView(String(m.MenuName)); setOpen(false); }}
                          className="block w-full px-2 py-1 text-left rounded hover:bg-gray-100"
                        >
                          {m.MenuLabel || m.MenuName}
                        </button>
                      ))}
                    </div>
                  )}
                </div>
              ))
            )}

            {/* Logout */}
            <button
              onClick={() => { logout(); setOpen(false); window.location.reload(); }}
              className="block w-full px-2 py-1 mt-2 text-left text-white bg-red-500 rounded"
            >
              Logout
            </button>
          </nav>
        </div>
      )}

      {/* Main content */}
      <main className="flex-1 p-4 overflow-y-auto ">
        {renderView()}
      </main>
    </div>
  );
};

export default AppShell;



// import React, { useState, useEffect } from "react";
// import { useAuth } from "../context/AuthContext";
// import { ChevronDown, ChevronRight } from "lucide-react";
// /* --- Pages --- */
// import Dashboard from "../pages/dashboard/Dashboard";
// import CustomerListPage from "../pages/customer/CustomerListPage";
// import AddEditCustomerPage from "../pages/customer/AddEditCustomerPage";
// import BillingModule from "../components/BillingModule/BillingModule";
// import SupplierListPage from "../pages/suppiler/SupplierListPage";
// import AddEditSupplierPage from "../pages/suppiler/AddEditSupplierPage";

// import OrderListPage from "../pages/order/OrderListPage";
// import AddOrderPage from "../pages/order/AddOrderPage";
// import OrderDetailsPage from "../pages/order/OrderDetailsPage";
// import ItemListPage from "../pages/item/ItemListPage";
// import PaymentScreen from "../pages/order/PaymentScreen";
// import OnlineOrderPage from "../pages/order/OnlineOrderPage";
// import CustomerLedgerPage from "../pages/Customerledger/CustomerLedgerPage";
// import ReceiptsPage from "../pages/ReceiptsPage/ReceiptsPage";
// import OrderNewItem from "../pages/order/OrderNewItem";
// import Report from "../pages/report/Report";
// import ItemMaster from "../pages/item/ItemMaster";
// import PurchaseOrderListPage from "../pages/order/Purchaseorderlist";
// import AddPurOrderPage from "../pages/order/AddPurOrderPage";
// import PurOrderDetailsPage from "../pages/order/PurOrderDetailPage";
// import PurOrderNewItem from "../pages/order/PurOrderNewItem";
// import StockListPage from "../pages/order/StockListPage";
// import AddStockPage from "../pages/order/AddStockPage";
// import StockDetailsPage from "../pages/order/StockDetailsPage";
// import StockNewItem from "../pages/order/StockNewItem";
// import DeliveryMIS from "../pages/report/DeliveryMIS";
// import ChangePassword from "../pages/order/ChangePassword";
// import Counter from "../pages/order/Counter";
// import OpeningBalanceList from "../pages/order/OpeningBalanceList";
// import OpeningBalanceAdd from "../pages/order/OpeningBalanceAdd";
// import OpeningBalanceEdit from "../pages/order/OpeningBalanceEdit";

// import SupplierReceiptsPage from "../pages/ReceiptsPage/SupplierReceiptsPage";

// /* --- UI & API --- */
// import Button from "../components/ui/Button";
// import api from "../api/api";

// import StockReport from "../pages/report/StockReport";
// import OrdervsStock from "../pages/report/OrdervsStock";

// import SalesPurchaseMis from "../pages/report/SalesPurchaseMis";
// import SalesPurReport from "../pages/report/SalesPurReport";


// import PendingView from "../pages/order/PendingView";
// import AllotOrderToPerson from "../pages/order/AllotOrderToPerson";

// import Employeemaster from "../pages/Master/Employeemaster";

// // import DeliveryList from "../pages/DeliveryList/Deliverylist";

// import DeliveryList from "../pages/DeliveryList/Deliverylist";
// import DeliveryPendingView from "../pages/DeliveryList/DeliveryPendingView";
// import DeliveryAllotOrderToPerson from "../pages/DeliveryList/DeliveryAllotOrderToPerson";

// import ExpensePage from "../pages/ReceiptsPage/ExpensePage";

// import SalesOrderListPage from "../pages/SalesOrder/SalesOrderList";
// import AddSalesOrderPage from "../pages/SalesOrder/AddSalesOrderPage";
// import SalesOrderNewItem from "../pages/SalesOrder/SalesOrderNewItem";
// import SalesOrderDetailsPage from "../pages/SalesOrder/SalesOrderDetailsPage";
// import AllotSalesOrderToPerson from "../pages/SalesOrder/AllotSalesOrderToPerson";
// import PendingSalesView from "../pages/SalesOrder/PendingSalesView";

// import PurchaseOrderListRev from "../pages/PurchaseOrder/PurchaseOrderListRev";
// import AddPurchaseOrderPage from "../pages/PurchaseOrder/AddPurchaseOrderPage";
// import PurchaseOrderNewItem from "../pages/PurchaseOrder/PurchaseOrderNewItem";
// import PurchaseOrderDetailsPage from "../pages/PurchaseOrder/PurchaseOrderDetailsPage";

// import Cancelpage from "../pages/ReceiptsPage/Cancelpage";
// import CancelListpage from "../pages/ReceiptsPage/CancelListpage"; // ✅ import

// import Bankaccount from "../pages/Bank/Bankaccount";

// const AppShell = () => {
//   const [view, setView] = useState("dashboard");
//   const [editingContext, setEditingContext] = useState(null);
//   const [open, setOpen] = useState(false);
//   const { user, logout } = useAuth();
//   const [companyInfo, setCompanyInfo] = useState({ name: "", address: "" });

//   // ✅ godown state (id + name)
//   const [gdName, setGdName] = useState(sessionStorage.getItem("gdname") || "");
//   const [gdid, setGdid] = useState(sessionStorage.getItem("gdid") || "");

//   const [cancelList, setCancelList] = useState([]);

//   const [openMenus, setOpenMenus] = useState({});
//   const toggleMenu = (menu) => {
//     setOpenMenus((prev) => ({ ...prev, [menu]: !prev[menu] }));
//   };

//   useEffect(() => {
//     const handleKeyDown = (e) => {
//       if (e.key === "F2") {
//         e.preventDefault();
//         setView("add-salesorder"); // same as clicking Orders menu/button
//       }
//     };

//     window.addEventListener("keydown", handleKeyDown);
//     return () => window.removeEventListener("keydown", handleKeyDown);
//   }, []);

//   useEffect(() => {
//     const fetchCompanyDetails = async () => {
//       try {
//         const usernameToSend = typeof user === "object" ? user.UsrName : user;
//         const data = await api.CompanyDetails(usernameToSend);

//         if (data?.Table?.length > 0) {
//           const c = data.Table[0];
//           setCompanyInfo({
//             name: c.Comname || "Company Name",
//           });
//         }

//         // ✅ also fetch godown name from gdid if missing/wrong
//         if (sessionStorage.getItem("gdid") && data?.Table1?.length > 0) {
//           const savedGdId = sessionStorage.getItem("gdid");
//           const gd = data.Table1.find(
//             (g) => g.GdId.toString() === savedGdId
//           );
//           if (gd) {
//             setGdName(gd.GodownName);
//             setGdid(savedGdId);
//             sessionStorage.setItem("gdname", gd.GodownName);
//           }
//         }
//       } catch (err) {
//         console.error("Error loading company details", err);
//         setCompanyInfo({ name: "Company Name", address: "" });
//       }
//     };
//     fetchCompanyDetails();
//   }, [user]);

//   // ✅ listen for godown changes
//   useEffect(() => {
//     const handleGodownChange = () => {
//       setGdName(sessionStorage.getItem("gdname") || "");
//       setGdid(sessionStorage.getItem("gdid") || "");
//     };

//     window.addEventListener("godownChanged", handleGodownChange);

//     // load on mount also
//     handleGodownChange();

//     return () => {
//       window.removeEventListener("godownChanged", handleGodownChange);
//     };
//   }, []);

//   const renderView = () => {
//     switch (view) {
//       case "dashboard":
//         return (
//           <Dashboard setView={setView} setEditingContext={setEditingContext} />
//         );

//       case "salesorders":
//         return (
//           <SalesOrderListPage
//             setView={setView}
//             setEditingContext={setEditingContext}
//           />
//         );
//       case "purchaseorders":
//         return (
//           <PurchaseOrderListRev
//             setView={setView}
//             setEditingContext={setEditingContext}
//           />
//         );

//       case "orders":
//         return (
//           <OrderListPage
//             setView={setView}
//             setEditingContext={setEditingContext}
//           />
//         );
//       case "add-order":
//         return (
//           <AddOrderPage
//             setView={setView}
//             setEditingContext={setEditingContext}

//           />
//         );


//       case "add-salesorder":
//         return (
//           <AddSalesOrderPage
//             setView={setView}
//             setEditingContext={setEditingContext}
//           />
//         );
//       case "add-purchaseorder":
//         return (
//           <AddPurchaseOrderPage
//             setView={setView}
//             setEditingContext={setEditingContext}
//           />
//         );
//       case "edit-order":
//         return <OrderDetailsPage setView={setView} context={editingContext} />;

//       case "edit-salesorder":
//         return <SalesOrderDetailsPage setView={setView} context={editingContext} />;

//       case "edit-purchaseorder":
//         return <PurchaseOrderDetailsPage setView={setView} context={editingContext} />;

//       case "new-order":
//         return <OrderNewItem setView={setView} context={editingContext || {}} />;
//       case "new-salesorder":
//         return <SalesOrderNewItem setView={setView} context={editingContext || {}} />;


//       case "pending-Salesview":
//         return (
//           <PendingSalesView setView={setView} context={PendingSalesView || {}} />
//         );
//       case "AllotSalesOrderToPerson":
//         return (
//           <AllotSalesOrderToPerson setView={setView} context={AllotSalesOrderToPerson || {}} />
//         );

//       case "new-purchaseorder":
//         return <PurchaseOrderNewItem setView={setView} context={editingContext || {}} />;

//       case "customers":
//         return (
//           <CustomerListPage
//             setView={setView}
//             setEditingContext={setEditingContext}
//           />
//         );
//       case "add-customer":
//         return (
//           <AddEditCustomerPage
//             setView={setView}
//             setCustomerId={setEditingContext}
//           />
//         );
//       case "edit-customer":
//         return (
//           <AddEditCustomerPage
//             setView={setView}
//             customerId={editingContext}
//             setCustomerId={setEditingContext}
//           />
//         );

//       case "supplier":
//         return (
//           <SupplierListPage
//             setView={setView}
//             setEditingContext={setEditingContext}
//           />
//         );
//       case "add-supplier":
//         return (
//           <AddEditSupplierPage
//             setView={setView}
//             setSupplierId={setEditingContext}
//           />
//         );
//       case "edit-supplier":
//         return (
//           <AddEditSupplierPage
//             setView={setView}
//             supplierId={editingContext}
//             setSupplierId={setEditingContext}
//           />
//         );

//       case "getPaymentval":
//         return (
//           <PaymentScreen editingContext={editingContext} setView={setView} />
//         );
//       case "online-order":
//         return <OnlineOrderPage />;
//       case "customer-ledger":
//         return <CustomerLedgerPage />;
//       case "receipt":
//         return <ReceiptsPage />;

//       case "Expense":
//         return <ExpensePage />;


//       case "Cancel":
//         return <Cancelpage setView={setView} cancelList={cancelList} setCancelList={setCancelList} />;

//       case "CancelNew":
//         return <CancelListpage setView={setView} setCancelList={setCancelList} />;



//       case "SupplierPayment":
//         return <SupplierReceiptsPage />;

//       case "report":
//         return <Report />;

//       case "deliverymis":
//         return <DeliveryMIS setView={setView} />;

//       case "salespurchasemis":
//         return <SalesPurchaseMis setView={setView} />;
//       case "salespurreport":
//         return <SalesPurReport setView={setView} context={editingContext} />


//       case "StockReport": return <StockReport />;
//       case "OrdervsStock": return <OrdervsStock />;

//       case "billing":
//         return (
//           <BillingModule
//             initialData={null}       // or provide context if needed
//             onBackToList={() => setView("dashboard")}
//             txnTypes={[]}            // you can fetch txnTypes using Project A's api
//             selectedTxnTypeId={""}
//             setSelectedTxnTypeId={() => { }}
//             loadingTxnTypes={false}
//             errorTxnTypes={null}
//           />
//         );

//       case "purchase":
//         return (
//           <PurchaseOrderListPage
//             setView={setView}
//             context={editingContext || {}}
//           />
//         );
//       case "addpur-order":
//         return (
//           <AddPurOrderPage
//             setView={setView}
//             setEditingContext={setEditingContext}
//           />
//         );
//       case "editpur-order":
//         return <PurOrderDetailsPage setView={setView} context={editingContext} />;
//       case "newpur-order":
//         return (
//           <PurOrderNewItem setView={setView} context={editingContext || {}} />
//         );

//       case "stock-adjustment":
//         return (
//           <StockListPage setView={setView} context={editingContext || {}} />
//         );
//       case "add-stock":
//         return (<AddStockPage setView={setView} setEditingContext={setEditingContext} />
//         );
//       case "edit-stock":
//         return <StockDetailsPage setView={setView} context={editingContext} />;
//       case "new-stock":
//         return <StockNewItem setView={setView} context={editingContext || {}} />;

//       case "itemmaster":
//         return <ItemMaster setView={setView} />;

//       case "changepassword":
//         return <ChangePassword setView={setView} />;

//       case "counter":
//         return <Counter setView={setView} />;



//       case "openingbalancelist":
//         return (
//           <OpeningBalanceList setView={setView} setEditingContext={setEditingContext} />);

//       case "openingBalanceForm": // 👈 Add button opens this
//         return <OpeningBalanceAdd setView={setView} />;

//       case "openingBalanceEdit":
//         return (<OpeningBalanceEdit setView={setView} editingContext={editingContext} />);

//       case "Employeemaster":
//         return <Employeemaster setView={setView} />;



//       case "pricelist":
//         return <ItemListPage setView={setView} />;
//       default:
//         return <Dashboard />;


//       case "pending-view":
//         return (
//           <PendingView setView={setView} context={PendingView || {}} />
//         );

//       case "AllotOrderToPerson":
//         return (
//           <AllotOrderToPerson setView={setView} context={AllotOrderToPerson || {}} />
//         );





//       case "Bankaccount":
//         return <Bankaccount setView={setView} />;


//       case "DeliveryList":
//         return <DeliveryList setView={setView} />;

//       case "delivery-pending-view":
//         return (
//           <DeliveryPendingView setView={setView} context={DeliveryPendingView || {}} />
//         );

//       case "DeliveryAllotOrderToPerson":
//         return (
//           <DeliveryAllotOrderToPerson setView={setView} context={DeliveryAllotOrderToPerson || {}} />
//         );

//     }


//   };



//   return (
//     <div className="flex min-h-screen bg-gray-100">
//       {/* Mobile hamburger */}
//       <button
//         className="fixed z-20 p-3 bg-white rounded shadow md:hidden top-3 left-3"
//         onClick={() => setOpen(!open)}
//       >
//         ☰
//       </button>

//       {/* Sidebar Desktop */}
//       <aside className="flex-shrink-0 hidden w-64 p-4 bg-white shadow-lg md:block">
//         <div className="mt-4 mb-2 text-2xl font-bold text-center text-gray-800">
//           {companyInfo.name || "Loading..."}
//         </div>
//         <div className="mb-6 text-xs text-center text-gray-600 leading-snug">
//           {companyInfo.address}
//         </div>

//         {/* ✅ Show current Godown info */}
//         {gdid && (
//           <div className="mb-4 text-center text-sm text-gray-700">
//             Godown: <span className="font-semibold">{gdName}</span>
//           </div>
//         )}

//         <nav className="space-y-2 text-sm">
//           {/* Dashboard */}
//           <button
//             onClick={() => setView("dashboard")}
//             className="block w-full text-left hover:bg-gray-100 rounded px-2 py-1"
//           >
//             Dashboard
//           </button>

//           {/* Sales Orders */}
//           <div>
//             <button
//               onClick={() => toggleMenu("salesorders")}
//               className="flex items-center justify-between w-full text-left font-semibold px-2 py-1 hover:bg-gray-100 rounded"
//             >
//               <span>Sales Orders</span>
//               {openMenus.salesorders ? <ChevronDown size={16} /> : <ChevronRight size={16} />}
//             </button>
//             {openMenus.salesorders && (
//               <div className="ml-4 space-y-1 mt-1">
//                 <button onClick={() => setView("salesorders")} className="block w-full text-left hover:bg-gray-100 rounded px-2 py-1">Sales Orders</button>

//               </div>
//             )}
//           </div>

//           {/* Orders */}
//           <div>
//             <button
//               onClick={() => toggleMenu("orders")}
//               className="flex items-center justify-between w-full text-left font-semibold px-2 py-1 hover:bg-gray-100 rounded"
//             >
//               <span>Orders</span>
//               {openMenus.orders ? <ChevronDown size={16} /> : <ChevronRight size={16} />}
//             </button>
//             {openMenus.orders && (
//               <div className="ml-4 space-y-1 mt-1">
//                 <button onClick={() => setView("orders")} className="block w-full text-left hover:bg-gray-100 rounded px-2 py-1">Orders</button>
//                 <button onClick={() => setView("customers")} className="block w-full text-left hover:bg-gray-100 rounded px-2 py-1">Customers</button>

//                 <button onClick={() => setView("itemmaster")} className="block w-full text-left hover:bg-gray-100 rounded px-2 py-1">Items </button>
//                 <button onClick={() => setView("pricelist")} className="block w-full text-left hover:bg-gray-100 rounded px-2 py-1">Price List</button>
//                 <button onClick={() => setView("Employeemaster")} className="block w-full text-left hover:bg-gray-100 rounded px-2 py-1">Employees </button>
//                 <button onClick={() => setView("DeliveryList")} className="block w-full text-left hover:bg-gray-100 rounded px-2 py-1">Delivery List</button>
//                 <button onClick={() => setView("Cancel")} className="block w-full px-2 py-1 text-left rounded hover:bg-gray-100">Cancelled Documents</button>
//               </div>
//             )}
//           </div>

//           {/* Purchase */}
//           <div>
//             <button
//               onClick={() => toggleMenu("purchase")}
//               className="flex items-center justify-between w-full text-left font-semibold px-2 py-1 hover:bg-gray-100 rounded"
//             >
//               <span>Purchase</span>
//               {openMenus.purchase ? <ChevronDown size={16} /> : <ChevronRight size={16} />}
//             </button>
//             {openMenus.purchase && (
//               <div className="ml-4 space-y-1 mt-1">
//                 <button onClick={() => setView("supplier")} className="block w-full text-left">Supplier</button>
//                 <button onClick={() => setView("purchase")} className="block w-full text-left">Purchase</button>
//                 <button onClick={() => setView("purchaseorders")} className="block w-full text-left">Purchase Orders</button>

//               </div>
//             )}
//           </div>

//           {/* Accounts */}
//           <div>
//             <button
//               onClick={() => toggleMenu("accounts")}
//               className="flex items-center justify-between w-full text-left font-semibold px-2 py-1 hover:bg-gray-100 rounded"
//             >
//               <span>Accounts</span>
//               {openMenus.accounts ? <ChevronDown size={16} /> : <ChevronRight size={16} />}
//             </button>
//             {openMenus.accounts && (
//               <div className="ml-4 space-y-1 mt-1">
//                 <button onClick={() => setView("receipt")} className="block w-full text-left">Receipt</button>
//                 <button onClick={() => setView("openingbalancelist")} className="block w-full text-left">Opening Balance</button>
//                 <button onClick={() => setView("SupplierPayment")} className="block w-full text-left">Supplier Payment</button>
//                 <button onClick={() => setView("Expense")} className="block w-full text-left">Expense</button>
//                 <button onClick={() => setView("Bankaccount")} className="block w-full text-left">Bank</button>
//               </div>
//             )}
//           </div>

//           {/* Stock */}
//           <div>
//             <button
//               onClick={() => toggleMenu("stock")}
//               className="flex items-center justify-between w-full text-left font-semibold px-2 py-1 hover:bg-gray-100 rounded"
//             >
//               <span>Stock</span>
//               {openMenus.stock ? <ChevronDown size={16} /> : <ChevronRight size={16} />}
//             </button>
//             {openMenus.stock && (
//               <div className="ml-4 space-y-1 mt-1">
//                 <button onClick={() => setView("stock-adjustment")} className="block w-full text-left">Stock Adjustment</button>
//               </div>
//             )}
//           </div>

//           {/* Report */}
//           <div>
//             <button
//               onClick={() => toggleMenu("report")}
//               className="flex items-center justify-between w-full text-left font-semibold px-2 py-1 hover:bg-gray-100 rounded"
//             >
//               <span>Report</span>
//               {openMenus.report ? <ChevronDown size={16} /> : <ChevronRight size={16} />}
//             </button>
//             {openMenus.report && (
//               <div className="ml-4 space-y-1 mt-1">
//                 <button onClick={() => setView("report")} className="block w-full text-left">Gnrl. Report </button>
//                 <button onClick={() => setView("customer-ledger")} className="block w-full text-left">Account Ledger</button>
//                 <button onClick={() => setView("deliverymis")} className="block w-full text-left">Delivery MIS</button>
//                 <button onClick={() => setView("StockReport")} className="block w-full text-left">Stock Report</button>
//                 <button onClick={() => setView("OrdervsStock")} className="block w-full text-left">Order vs Stock</button>
//                 <button onClick={() => setView("salespurchasemis")} className="block w-full text-left">Sales/Purchase-MIS</button>
//               </div>
//             )}
//           </div>

//           {/* Online Order */}
//           <button
//             onClick={() => setView("online-order")}
//             className="block w-full text-left hover:bg-gray-100 rounded px-2 py-1"
//           >
//             Online Order
//           </button>


//           <button
//             onClick={() => setView("billing")}
//             className="block w-full text-left hover:bg-gray-100 rounded px-2 py-1"
//           >
//             Billing
//           </button>

//           <button
//             onClick={() => setView("changepassword")}
//             className="block w-full text-left hover:bg-gray-100 rounded px-2 py-1"
//           >
//             Change Password
//           </button>
//           <button
//             onClick={() => setView("counter")}
//             className="block w-full text-left hover:bg-gray-100 rounded px-2 py-1"
//           >
//             Counter {gdName && <span className="ml-1 text-blue-600">({gdName})</span>}
//           </button>
//         </nav>
//         {/* Logout */}
//         <div className="mt-auto text-center border-t pt-2">
//           <p className="text-sm font-semibold">{user.UsrName}</p>
//           <button
//             onClick={logout}
//             className="w-full bg-red-500 text-white px-2 py-1 mt-2 rounded hover:bg-red-600"
//           >
//             Logout
//           </button>
//         </div>
//       </aside>

//       {/* Sidebar Mobile Popup */}
//       {open && (
//         <div className="absolute z-30 w-64 p-4 bg-white rounded shadow-lg md:hidden top-14 left-3">
//           {gdid && (
//             <div className="mb-3 text-center text-sm text-gray-700">
//               Godown: <span className="font-semibold">{gdName}</span>
//             </div>
//           )}

//           <nav className="space-y-2 text-sm">
//             {/* Dashboard */}
//             <button
//               onClick={() => {
//                 setView("dashboard");
//                 setOpen(false);
//               }}
//               className="block w-full text-left hover:bg-gray-100 rounded px-2 py-1"
//             >
//               Dashboard
//             </button>
//             {/* Sales Orders */}
//             <div>
//               <button
//                 onClick={() => toggleMenu("salesorders")}
//                 className="flex items-center justify-between w-full text-left font-semibold px-2 py-1 hover:bg-gray-100 rounded"
//               >
//                 <span>Sales Orders</span>
//                 {openMenus.salesorders ? <ChevronDown size={16} /> : <ChevronRight size={16} />}
//               </button>
//               {openMenus.salesorders && (
//                 <div className="ml-4 space-y-1 mt-1">
//                   <button onClick={() => { setView("salesorders"); setOpen(false); }} className="block w-full text-left hover:bg-gray-100 rounded px-2 py-1">Sales Orders</button>



//                 </div>
//               )}
//             </div>


//             {/* Orders */}
//             <div>
//               <button
//                 onClick={() => toggleMenu("orders")}
//                 className="flex items-center justify-between w-full text-left px-2 py-1 font-medium hover:bg-gray-100 rounded"
//               >
//                 <span>Orders</span>
//                 {openMenus.orders ? <ChevronDown size={16} /> : <ChevronRight size={16} />}
//               </button>
//               {openMenus.orders && (
//                 <div className="ml-4 mt-1 space-y-1">
//                   <button onClick={() => { setView("orders"); setOpen(false); }} className="block w-full text-left hover:bg-gray-100 rounded px-2 py-1">Orders</button>
//                   <button onClick={() => { setView("customers"); setOpen(false); }} className="block w-full text-left hover:bg-gray-100 rounded px-2 py-1">Customers</button>

//                   <button onClick={() => { setView("itemmaster"); setOpen(false); }} className="block w-full text-left hover:bg-gray-100 rounded px-2 py-1">Items </button>
//                   <button onClick={() => { setView("pricelist"); setOpen(false); }} className="block w-full text-left hover:bg-gray-100 rounded px-2 py-1">Price List</button>
//                   <button onClick={() => { setView("Employeemaster"); setOpen(false); }} className="block w-full text-left hover:bg-gray-100 rounded px-2 py-1">Employees </button>
//                   <button onClick={() => { setView("DeliveryList"); setOpen(false); }} className="block w-full text-left hover:bg-gray-100 rounded px-2 py-1">Delivery List</button>
//                   <button onClick={() => { setView("Cancel"); setOpen(false); }} className="block w-full px-2 py-1 text-left rounded hover:bg-gray-100">Cancelled Documents</button>

//                 </div>
//               )}
//             </div>

//             {/* Purchase */}
//             <div>
//               <button
//                 onClick={() => toggleMenu("purchase")}
//                 className="flex items-center justify-between w-full text-left px-2 py-1 font-medium hover:bg-gray-100 rounded"
//               >
//                 <span>Purchase</span>
//                 {openMenus.purchase ? <ChevronDown size={16} /> : <ChevronRight size={16} />}
//               </button>
//               {openMenus.purchase && (
//                 <div className="ml-4 mt-1 space-y-1">
//                   <button onClick={() => { setView("supplier"); setOpen(false); }} className="block w-full text-left hover:bg-gray-100 rounded px-2 py-1">Supplier</button>
//                   <button onClick={() => { setView("purchase"); setOpen(false); }} className="block w-full text-left hover:bg-gray-100 rounded px-2 py-1">Purchase</button>
//                   <button onClick={() => { setView("purchaseorders"); setOpen(false); }} className="block w-full text-left hover:bg-gray-100 rounded px-2 py-1">Purchase Orders</button>
//                 </div>
//               )}
//             </div>

//             {/* Accounts */}
//             <div>
//               <button
//                 onClick={() => toggleMenu("accounts")}
//                 className="flex items-center justify-between w-full text-left px-2 py-1 font-medium hover:bg-gray-100 rounded"
//               >
//                 <span>Accounts</span>
//                 {openMenus.accounts ? <ChevronDown size={16} /> : <ChevronRight size={16} />}
//               </button>
//               {openMenus.accounts && (
//                 <div className="ml-4 mt-1 space-y-1">
//                   <button onClick={() => { setView("receipt"); setOpen(false); }} className="block w-full text-left hover:bg-gray-100 rounded px-2 py-1">Receipt</button>
//                   <button onClick={() => { setView("openingbalancelist"); setOpen(false); }} className="block w-full text-left hover:bg-gray-100 rounded px-2 py-1">Opening Balance</button>
//                   <button onClick={() => { setView("SupplierPayment"); setOpen(false); }} className="block w-full text-left hover:bg-gray-100 rounded px-2 py-1">Supplier Payment</button>

//                   <button onClick={() => { setView("Expense"); setOpen(false); }} className="block w-full text-left hover:bg-gray-100 rounded px-2 py-1">Expense</button>
//                   <button onClick={() => { setView("Bankaccount"); setOpen(false); }} className="block w-full text-left hover:bg-gray-100 rounded px-2 py-1">Bank</button>
//                 </div>
//               )}
//             </div>

//             {/* Stock */}
//             <div>
//               <button
//                 onClick={() => toggleMenu("stock")}
//                 className="flex items-center justify-between w-full text-left px-2 py-1 font-medium hover:bg-gray-100 rounded"
//               >
//                 <span>Stock</span>
//                 {openMenus.stock ? <ChevronDown size={16} /> : <ChevronRight size={16} />}
//               </button>
//               {openMenus.stock && (
//                 <div className="ml-4 mt-1 space-y-1">
//                   <button onClick={() => { setView("stock-adjustment"); setOpen(false); }} className="block w-full text-left hover:bg-gray-100 rounded px-2 py-1">Stock Adjustment</button>
//                 </div>
//               )}
//             </div>

//             {/* Report */}
//             <div>
//               <button
//                 onClick={() => toggleMenu("report")}
//                 className="flex items-center justify-between w-full text-left px-2 py-1 font-medium hover:bg-gray-100 rounded"
//               >
//                 <span>Report</span>
//                 {openMenus.report ? <ChevronDown size={16} /> : <ChevronRight size={16} />}
//               </button>
//               {openMenus.report && (
//                 <div className="ml-4 mt-1 space-y-1">
//                   <button onClick={() => { setView("report"); setOpen(false); }} className="block w-full text-left hover:bg-gray-100 rounded px-2 py-1">Report (Party Ledger)</button>
//                   <button onClick={() => { setView("customer-ledger"); setOpen(false); }} className="block w-full text-left hover:bg-gray-100 rounded px-2 py-1">Account Ledger</button>
//                   <button onClick={() => { setView("deliverymis"); setOpen(false); }} className="block w-full text-left hover:bg-gray-100 rounded px-2 py-1">Delivery MIS</button>
//                   <button onClick={() => { setView("StockReport"); setOpen(false); }} className="block w-full px-2 py-1 text-left rounded hover:bg-gray-100">StockReport</button>
//                   <button onClick={() => { setView("OrdervsStock"); setOpen(false); }} className="block w-full px-2 py-1 text-left rounded hover:bg-gray-100">OrdervsStock</button>
//                   <button onClick={() => { setView("salespurchasemis"); setOpen(false); }} className="block w-full px-2 py-1 text-left rounded hover:bg-gray-100">Sales/Purchase-MIS</button>

//                 </div>
//               )}
//             </div>

//             {/* Online Order */}
//             <button
//               onClick={() => { setView("online-order"); setOpen(false); }}
//               className="block w-full text-left hover:bg-gray-100 rounded px-2 py-1"
//             >
//               Online Order
//             </button>
//             {/* Billing */}
//             <button
//               onClick={() => { setView("billing"); setOpen(false); }}
//               className="block w-full text-left hover:bg-gray-100 rounded px-2 py-1"
//             >
//               Billing
//             </button>

//             {/* Change Password */}
//             <button
//               onClick={() => { setView("changepassword"); setOpen(false); }}
//               className="block w-full text-left hover:bg-gray-100 rounded px-2 py-1"
//             >
//               Change Password
//             </button>

//             {/* Counter */}
//             <button
//               onClick={() => { setView("counter"); setOpen(false); }}
//               className="block w-full text-left hover:bg-gray-100 rounded px-2 py-1"
//             >
//               Counter {gdName && <span className="ml-1 text-blue-600">({gdName})</span>}
//             </button>

//             {/* Logout */}
//             <button
//               onClick={() => { logout(); setOpen(false); window.location.reload(); }}
//               className="block w-full text-left bg-red-500 text-white rounded px-2 py-1 mt-2"
//             >
//               Logout
//             </button>
//           </nav>
//         </div>
//       )}


//       {/* Main content area */}
//       <main className="flex-1 p-4 overflow-y-auto ">{renderView()}</main>
//     </div>
//   );
// };

// export default AppShell;




